import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class AccountSettingActions {

    static getAccountSettingsByUserId = createAction('[Admin:AccountSetting] Get Account Setting by UserId ', props<{user: any}>());
    static getAccountSettingsByUserIdSuccess = createAction('[Admin:AccountSetting] Get Account Setting by UserId Success ', props<{settings: any}>());
}
